import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["scrollSection"];
  offset = 50;
  isLoading = false;

  connect() {
    this.startScrolling();
    window.addEventListener("resize", this.adjustScrollSpeed.bind(this));
    this.scrollSection.addEventListener("mouseenter", this.pauseScrolling.bind(this));
    this.scrollSection.addEventListener("mouseleave", this.resumeScrolling.bind(this));

    this.autoLoadInterval = setInterval(() => {
      this.loadMoreUsers();
    }, 15000);
  }

  disconnect() {
    window.removeEventListener("resize", this.adjustScrollSpeed.bind(this));
    this.scrollSection.removeEventListener("mouseenter", this.pauseScrolling.bind(this));
    this.scrollSection.removeEventListener("mouseleave", this.resumeScrolling.bind(this));
    clearInterval(this.autoLoadInterval);

    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
    }
  }

  startScrolling() {
    const scrollSection = document.getElementById("main-cards-section");
    if (!scrollSection) return;

    this.scrollSection = scrollSection;
    this.scrollPosition = this.scrollPosition || 0;
    this.scrollSpeed = this.calculateSpeed();

    const scroll = () => {
      this.scrollPosition -= this.scrollSpeed;
      if (this.scrollPosition <= -this.scrollSection.scrollWidth) {
        this.scrollPosition = 0;
      }
      this.scrollSection.style.transform = `translateX(${this.scrollPosition}px)`;
      this.scrollAnimationFrame = requestAnimationFrame(scroll);
    };

    this.scrollAnimationFrame = requestAnimationFrame(scroll);
  }

  calculateSpeed() {
    const sectionWidth = this.scrollSection.scrollWidth;

    let baseSpeed;
    if (window.innerWidth >= 1024) {
      baseSpeed = 3;
    } else if (window.innerWidth >= 750) {
      baseSpeed = 2;
    } else {
      baseSpeed = 1;
    }

    return baseSpeed;
  }

  adjustScrollSpeed() {
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
    }
    this.startScrolling();
  }

  pauseScrolling() {
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
      this.scrollAnimationFrame = null;
    }
  }

  resumeScrolling() {
    if (!this.scrollAnimationFrame) {
      this.startScrolling();
    }
  }

  loadMoreUsers() {
    if (this.isLoading) return;
    this.isLoading = true;

    fetch(`/load_more_users?offset=${this.offset}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.stop_loading) {
        this.stopLoading();
      } else {
        this.scrollSection.innerHTML += data.html;
        this.offset += 50;
      }
      this.isLoading = false;
    })
    .catch(error => {
      this.isLoading = false;
    });
  }

  stopLoading() {
    clearInterval(this.autoLoadInterval);
  }
}
